// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + "." + {"2897":"470d2a82c3a6f27a75ff","6400":"f34af5914e8f3e4be6c4"}[chunkId] + ".js";
};